module.exports = function() {
    if (!this.opts.checkbox) {
        return false;
    }

    const getters = this.$store.getters;

    return getters[`${this.name}_CHECKBOX/hasSelected`];
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/computed/has-checkbox-selected.js